import {useEffect} from "react";
import isEmpty from "is-empty";
import {useModalStore} from "@/Stores/Site/ModalStore";

let timerSecretSanta = null;

export default function useShowSecretSanta(props) {
    const {mobileApp = false, secretSanta = false} = props;

    const openSecretSantaModal = useModalStore(state => state.openSecretSantaModal);

    useEffect(() => {
        /**
         * Очистка таймера если был установлен ранее
         */
        if (!secretSanta && timerSecretSanta) {
            clearTimeout(timerSecretSanta);
        }

        /**
         * Проходим далее если:
         * 1. Если действует акция (определяет сервер)
         * 2. Если запущен таймер
         * 3. Окно показывается впервые
         * 4. Если открыли не из приложения
         */
        if (
            !secretSanta ||
            timerSecretSanta ||
            !isEmpty(sessionStorage.getItem('secretSanta')) ||
            mobileApp
        ) {
            return;
        }

        timerSecretSanta = setTimeout(() => {
            openSecretSantaModal(); // Показываем модальное окно "Тайный санта"
        }, 30000); // 30 секунд = 30000 миллисекунд
    }, [secretSanta]);
}
